// extracted by mini-css-extract-plugin
module.exports = {"breakpointTablet":"768px","mortgage":"MortgageCard_mortgage__IRFvs"};